import React from 'react';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';

// Material-UI
import BlockIcon from '@mui/icons-material/Block';
import { blueGrey, green, red } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import PendingIcon from '@mui/icons-material/Pending';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  RequestSummaryPass
} from '../../models';

import {
  TransferablePassStatus
} from '../../global';

// UTC to local date formatting hooks
import { useDates } from '../../hooks/UseDates';

interface RequestSummaryPassesProps {
  passes: Array<RequestSummaryPass>;
}

const RequestSummaryPasses: React.FC<RequestSummaryPassesProps> = (props) => {

  const { dateStringToLocalDateFormatted } = useDates();

  // #region Styles

  const theme = useTheme();
  const styles = {
    confirmed: {
      color: green[500]
    },
    deined: {
      color: red[500]
    },
    guestsContainer: {
      margin: theme.spacing(1, 0, 1, 0)
    },
    pending: {
      color: blueGrey[500]
    }
  };

  // #endregion

  // #region Methods

  /*
* Render the request status icon
*/
  const renderStatus = (statusID: number, status: string) => {

    switch (statusID) {
      case TransferablePassStatus.Requested:
        return (
          <Tooltip title={status} arrow>
            <PendingIcon fontSize="medium" sx={styles.pending} />
          </Tooltip>
        )
      case TransferablePassStatus.Confirmed:
        return (
          <Tooltip title={status} arrow>
            <CheckCircleIcon fontSize="medium" sx={styles.confirmed} />
          </Tooltip>
        )
      case TransferablePassStatus.Denied:
        return (
          <Tooltip title={status} arrow>
            <BlockIcon fontSize="medium" sx={styles.deined} />
          </Tooltip>
        )
      default:
        return (<span />)
    }

  }

  /*
 * Render members 
 */
  const renderPasses = () => {

    let ps: Array<ReactJSXElement> = [];

    props.passes.forEach(p => {
      ps.push(
        <Grid container spacing={1} alignItems="center">
          <Grid size={1}>
            {renderStatus(p.statusID, p.status)}
          </Grid>
          <Grid size={4}>
            <Typography variant="body2">{dateStringToLocalDateFormatted(p.passDate, 'EEEEEE MM/dd')}</Typography>
          </Grid>
        </Grid>
      );
    });

    return ps;
  }

  // #endregion

  return (
    <Grid container sx={styles.guestsContainer}>
      <Grid container>
        <Typography variant="button">Passes</Typography>
      </Grid>
      <Grid container>
        {renderPasses()}
      </Grid>
    </Grid>
  );

}

export default RequestSummaryPasses;